import SingleView from 'components/Reward/RrcPromo/SingleView/SingleView';

export default SingleView;
